import Head from "next/head";
import { useRouter } from "next/router";
import { getHreflangAlternates } from "../utils/hreflang";
import { BRAND_SITE_NAME } from "../utils/brand";
import { a10vShareFromOpen } from "../utils/pumps/a10v-share-meta";

const SITE = "https://www.tu.biz";

/** Paths that should not appear in Google results. */
const NOINDEX_PATHS = new Set([
	"/thank-you",
	"/fallback",
	"/interactive",
	"/home2",
	"/subscribe",
	"/staff-chat",
	"/staff-visits",
]);

function canonicalPath(asPath) {
	const path = asPath.split("#")[0].split("?")[0] || "/";
	if (path === "/") return "/es";
	return path;
}

export default function DefaultSeo() {
	const router = useRouter();
	// `pathname` is stable on SSG pages; empty `asPath` on first client pass caused
	// canonical/hreflang to flip to `/en` and trigger React #418 hydration errors.
	const path = canonicalPath(router.pathname || "/");
	const canonical = `${SITE}${path}`;

	const noindex =
		NOINDEX_PATHS.has(router.pathname) ||
		router.pathname.startsWith("/this") ||
		router.pathname.startsWith("/_404") ||
		router.pathname.startsWith("/pdf/");

	const hreflang = noindex ? null : getHreflangAlternates(path);

	const pageSetsOgUrl =
		router.pathname.startsWith("/en/video-blogs/") ||
		router.pathname.startsWith("/es/video-blog/");
	const seriesShare =
		router.pathname ===
		"/es/productos/hidraulicos/bombas/bombas_de_pistones/series_a10v_a4v"
			? a10vShareFromOpen(router.query.open)
			: router.pathname ===
				  "/en/products/hydraulics/pumps/piston_pumps/series_a10v_a4v"
				? a10vShareFromOpen(router.query.open, "en")
				: null;

	return (
		<Head>
			{noindex ? null : (
				<link key="canonical" rel="canonical" href={canonical} />
			)}
			{noindex || pageSetsOgUrl ? null : (
				<meta
					key="og-url"
					property="og:url"
					content={seriesShare?.ogURL || canonical}
					id="meta-og-url"
				/>
			)}
			{hreflang?.map((alt) => (
				<link
					key={`hreflang-${alt.hreflang}`}
					rel="alternate"
					hrefLang={alt.hreflang}
					href={alt.href}
				/>
			))}
			{noindex ? <meta name="robots" content="noindex, follow" /> : null}
			{/* Brand on every page; lib/branded-head.js normalizes the property + key. */}
			<meta property="og:site_name" content={BRAND_SITE_NAME} />
			<meta name="application-name" content={BRAND_SITE_NAME} />
		</Head>
	);
}
